import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { Reveal } from './Reveal';

const EASE = [0.16, 1, 0.3, 1];

const AboutSection = () => {
  const { t, language } = useLanguage();

  return (
    <section id="nosotros" className="bg-obsidian py-24 md:py-32 relative overflow-hidden">
      <div className="absolute bottom-0 right-0 w-[34rem] h-[34rem] bg-brand/8 rounded-full blur-[140px] pointer-events-none" />

      <div className="container mx-auto px-6 lg:px-10 relative z-10">
        <div className="grid md:grid-cols-2 gap-16 lg:gap-24 items-center">
          <Reveal>
            <p className="overline mb-5">{t('about.sectionTitle')}</p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light text-white mb-8 tracking-tight leading-tight">
              {t('about.title1')}
              <span className="block text-gradient-blue font-normal">{t('about.title2')}</span>
            </h2>

            <div className="space-y-6 text-white/55 leading-relaxed">
              <p>
                {language === 'es' ? (
                  <>En <span className="text-white font-medium">Domodomotics</span>, creemos que la mejor tecnología es aquella que no se ve pero se siente. Durante más de una década, hemos estado a la vanguardia de la automatización inteligente, transformando espacios ordinarios en entornos extraordinarios.</>
                ) : (
                  <>At <span className="text-white font-medium">Domodomotics</span>, we believe the best technology is the kind you don&apos;t see but feel. For over a decade, we have been at the forefront of intelligent automation, transforming ordinary spaces into extraordinary environments.</>
                )}
              </p>
              <p>
                {language === 'es' ? (
                  <>Nuestro equipo de expertos combina conocimientos profundos en <span className="text-white">ingeniería</span>, <span className="text-white">diseño</span> y <span className="text-white">tecnología</span> para crear soluciones que se adaptan perfectamente a su estilo de vida.</>
                ) : (
                  <>Our team of experts combines deep knowledge in <span className="text-white">engineering</span>, <span className="text-white">design</span> and <span className="text-white">technology</span> to create solutions that perfectly adapt to your lifestyle.</>
                )}
              </p>
            </div>

            <div className="mt-10 flex flex-wrap gap-4">
              <a href="#contacto" className="btn-primary px-8 py-3.5 rounded-sm text-sm uppercase tracking-wider font-medium">
                {language === 'es' ? 'Trabajemos Juntos' : "Let's Work Together"}
              </a>
              <a href="#proyectos" className="btn-ghost px-8 py-3.5 rounded-sm text-sm uppercase tracking-wider font-medium">
                {language === 'es' ? 'Nuestro Trabajo' : 'Our Work'}
              </a>
            </div>
          </Reveal>

          <motion.div
            initial={{ opacity: 0, scale: 1.05 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 1, ease: EASE }}
            className="relative"
          >
            <div className="absolute -inset-4 bg-brand/10 rounded-3xl blur-2xl" />
            <img
              src="https://images.unsplash.com/photo-1708113388262-17fdf0e21205?w=900&q=80"
              alt="About Domodomotics"
              className="relative rounded-2xl w-full h-[460px] object-cover shadow-2xl"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
